'use client'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog"
import { ProxyImage } from "@/components/ui/ProxyImage"
import { getImagePath } from "@/lib/helpers/imageHelpers"
import type { CourseDetail, Name_lesson } from "@/lib/types/course/detail"
import { MediaPlayer, MediaProvider } from "@vidstack/react"
import { defaultLayoutIcons, DefaultVideoLayout } from "@vidstack/react/player/layouts/default"
import "@vidstack/react/player/styles/default/layouts/video.css"
import "@vidstack/react/player/styles/default/theme.css"
import { Calendar, Clock, Play, Users, Video, Tag } from "lucide-react"
import Link from "@/components/Link"
import { useRef, useState, useMemo, useEffect } from "react"
import { StringUtils } from "@/lib/helpers/course/StringUtils"
interface IntroductionProps {
	course: CourseDetail
}

export default function Introduction({ course }: IntroductionProps) {
	const [selectedLesson, setSelectedLesson] = useState<Name_lesson | string | null>(null)
	const [isPreview, setIsPreview] = useState(false)
	useEffect(() => {
		if (course.video_link !== 'R1BFTVNfMzIxMjIyMw==' || course.name_lessons?.find(lesson => lesson.is_preview)) {
			setIsPreview(true)
		} else {
			setIsPreview(false)
		}
	}, [course.video_link, course.name_lessons])
	const selectedLessonParsed = useMemo(() => {
		if (typeof selectedLesson === 'string') {
			return {
				name: selectedLesson,
				link_lessons: selectedLesson
			}
		}
		return selectedLesson
	}, [selectedLesson])

	const playerRef = useRef(null)
	return (
		<>
			<div className="flex flex-col gap-4 text-white md:flex-row">
				<div className="flex flex-col justify-between space-y-6 md:w-3/4">
					{/* <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-6">
						<div className="flex items-center">
							<Clock className="mr-2 h-5 w-5" />
							<div>
								<div className="text-sm opacity-80">Thời lượng</div>
								<div><b>{course.hour}</b> giờ</div>
							</div>
						</div>
						<div className="flex items-center">
							<Video className="mr-2 h-5 w-5" />
							<div>
								<div className="text-sm opacity-80">Số bài học</div>
								<div><b>{course.total_videos}</b> videos</div>
							</div>
						</div>
						<div className="flex items-center">
							<Users className="mr-2 h-5 w-5" />
							<div>
								<div className="text-sm opacity-80">Học viên</div>
								<div><b>{course.count_user}</b></div>
							</div>
						</div>
						<div className="flex items-center">
							<Calendar className="mr-2 h-5 w-5" />
							<div>
								<div className="text-sm opacity-80">Lịch học</div>
								<div><b>{course.schedule}</b></div>
							</div>
						</div>
					</div> */}
					<div className="prose prose-invert max-w-none">
						<p className="whitespace-pre-line">{course.short_description}</p>
					</div>
					<div className="mb-1">
						<Tag className="inline-block h-4 w-4" /> Tag:{" "}
						{(() => {
							const tags = typeof course.tag === 'string'
								? course.tag.split(',').map((tag: string) => tag.trim()).filter(Boolean)
								: Array.isArray(course.tag)
									? course.tag
									: [];

							return tags.map((tag: string, index: number) => (
								<span key={tag}>
									<Link
										href={`/course/search?q=${encodeURIComponent(tag)}`}
										className="font-bold transition-colors hover:text-primary"
									>
										{tag}
									</Link>
									{index < tags.length - 1 && ", "}
								</span>
							));
						})()}
					</div>
				</div>
				<div className="md:w-1/4">
					<div className="group relative cursor-pointer" onClick={() => setSelectedLesson(course.name_lessons?.find(lesson => lesson.is_preview) || course.video_link || null)}>
						<ProxyImage
							src={getImagePath(course, "course", "sm", true)}
							alt="CourseImage"
							width={324}
							height={182}
							className="h-62 w-full rounded-lg object-cover opacity-100 shadow-md transition-opacity group-hover:opacity-90"
						/>
						{(isPreview) && (
							<div className="absolute inset-0 flex items-center justify-center rounded-lg transition-colors group-hover:bg-black/20">
								<div className="h-16 w-16 rounded-full bg-black/40 text-white transition-transform duration-200 group-hover:scale-110">
									<div className="flex h-full w-full items-center justify-center">
										<Play className="h-8 w-8" />
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<Dialog open={!!selectedLesson} onOpenChange={() => setSelectedLesson(null)}>
				<DialogContent className="min-w-[75vw] sm:max-w-[800px]">
					<DialogHeader>
						<DialogTitle>{course?.name}</DialogTitle>
					</DialogHeader>
					<div className="w-full">
						<MediaPlayer
							ref={playerRef}
							src={StringUtils.toYoutubeUrl(selectedLessonParsed?.link_lessons || '')}
							viewType="video"
							streamType="on-demand"
							logLevel="warn"
							crossOrigin
						>
							<MediaProvider />
							<DefaultVideoLayout icons={defaultLayoutIcons} />
						</MediaPlayer>
					</div>
				</DialogContent>
			</Dialog>
		</>
	)
}
